// extracted by mini-css-extract-plugin
export default {"videoPlayer3Container":"VideoPlaye3_videoPlayer3Container__5T8OY","videoContainer":"VideoPlaye3_videoContainer__nZRiN","full":"VideoPlaye3_full__bP+Pv"};